import { IGif } from '@giphy/js-types'
import React, { useContext, useEffect, useState } from 'react'
import { searchClips } from 'shared/api'
import SearchOptionsContext from 'shared/components/context/search-options'
import { getPingbackId } from '@giphy/js-util'
import ClipsCarousel from 'shared/components/clips-carousel'
import styled from 'styled-components'
import isMobile from 'shared/util/is-mobile'

const GridSectionHeader = styled.div`
    display: flex;
    justify-content: flex-start;
    padding: 0 5px;
    box-sizing: border-box;
    margin-top: 7px;
    font-family: InterFace;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0.25px;
`

type Props = {
    term: string
}

const SearchClipsCarousel = ({ term }: Props) => {
    const { setClipSearchResponseId } = useContext(SearchOptionsContext)
    const [clips, setClips] = useState<IGif[]>([])
    const pingbackId = getPingbackId()

    const fetchClips = async (term: string, pingbackId: string) => {
        const { data, meta } = await searchClips({ q: term, limit: 20, pingbackId: pingbackId })
        setClips(data)
        setClipSearchResponseId(meta.response_id)
    }
    useEffect(() => {
        !clips.length && fetchClips(term, pingbackId)
    }, [])

    return (
        <>
            {!!clips.length && (
                <>
                    {isMobile() && <GridSectionHeader>GIPHY Clips</GridSectionHeader>}
                    <ClipsCarousel clips={clips} />
                </>
            )}
        </>
    )
}

export default SearchClipsCarousel
